import IMAGES from "../assets/images";

export const showRights = (right: string) => {

   const prefix: string[] = right.split(".");
   //    console.log(`${prefix[1]} ${prefix[2]}`);
   if (prefix.length == 2 && prefix[1] == "") {
      let result = prefix[0].replace(/[_\.]/g, ' ')
      return result
   } else if (prefix.length == 2 && prefix[1] != "") {
      let result = prefix[1].replace(/[_\.]/g, ' ')
      return result
   } else if (prefix.length == 3 && prefix[2] != '') {
      const combine: string = `-- ${prefix[2]} `
      let result = combine.replace(/[_\.]/g, ' '); // Replacing underscores and periods with spaces
      result = result.replace('--', ' ')
      return result
   }
   else if (prefix.length == 3 && prefix[2] == '') {
      const combine: string = `${prefix[1]} `
      let result = combine.replace(/[_\.]/g, ' ')
      return result
   }
}

export const countPrefixLength = (right: string) => {
   const prefix: string[] = right.split(".");
   //    console.log(`${prefix[1]} ${prefix[2]}`);
   if (prefix.length == 2 && prefix[1] == "") {
      let result = 0
      return result
   } else if (prefix.length == 2 && prefix[1] != "") {
      let result = 1
      return result
   } else if (prefix.length == 3 && prefix[2] != '') {
      const combine: string = `${prefix[2]} `
      let result = 2
      return result
   }
   else if (prefix.length == 3 && prefix[2] == '') {
      const combine: string = `${prefix[1]} `
      let result = 1
      return result
   }
}

export const getPaymentsIcons = (data: any) => {
   var paymentMethod = data;
   var result = `${IMAGES.card}`
   switch (paymentMethod) {
      case "CASH":
         result = `${IMAGES.cash}`;
         break;
      case "MASTERCARD":
         result = `${IMAGES.masterCard}`;
         break;
      case "VISA":
         result = `${IMAGES.visa}`;
         break;

      case "KNET":
         result = `${IMAGES.knet}`;
         break;
      case "PARTIAL":
         result = `${IMAGES.split}`;
         break;
         case "APPLE_PAY":
         result = `${IMAGES.applePay}`;
         break;
      default:
         result = `${IMAGES.card}`;
         break;
   }
   return result;
}


export const getLang = (value: { en: string; ar?: string }, langValue: string): string => {
   const lang = langValue;
   let result = value.en;
 
   switch (lang) {
     case "en":
       result = value.en;
       break;
     case "ar":
       result = value.ar ? value.ar : value.en;
       break;
     default:
       result = value.en;
       break;
   }
 
   return result;
 };
 
 export const getLangSearch = (value: { en: string; ar?: string }, langValue: string): string => {
   const lang = langValue;
   let result = value.en;
 
   switch (lang) {
     case "en":
       result = value.en;
       break;
     case "ar":
       // result = value.ar ? value.ar : value.en;
       result = value.en;
       break;
     default:
       result = value.en;
       break;
   }
 
   return result;
 };
 